import React from "react";

import { Box, Typography, TypographyProps } from "@mui/material";

export const Para12Text: React.FC<
  TypographyProps<React.ElementType, { component?: React.ElementType }> & {
    fontWeight?: number;
  }
> = ({ fontWeight = 400, ...otherProps }) => (
  <Typography component="div">
    <Box
      fontSize={12}
      lineHeight={"17.5px"}
      fontWeight={fontWeight}
      letterSpacing={0.5}
    >
      <Typography variant="inherit" component="p" {...otherProps} />
    </Box>
  </Typography>
);
